// 图表的序列色（设计系统 Chart）。

/** 第 i 条序列的颜色，依次取 chart-1 到 chart-6，超过 6 条从头循环。只用作线、柱与色块，不作文字。 */
export function seriesColor(i: number): string {
  return `var(--chart-${(i % 6) + 1})`;
}
